export default () => (
  /**
   * Icone de uma regua.
   * Responsável por tirar medidas no mapa.
   * Encontrado no menu de ferramentas.
   */
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9102 6.10102L12.8702 1.06102C12.5102 0.701016 11.9702 0.701016 11.6102 1.06102L0.450176 12.221C0.0901758 12.581 0.0901758 13.121 0.450176 13.481L5.49018 18.521C5.85018 18.881 6.39018 18.881 6.75018 18.521C8.82018 16.361 15.5702 9.61102 18.0002 7.27102C18.2702 7.00102 18.2702 6.37102 17.9102 6.10102ZM6.12018 16.631L2.43018 12.941L12.3302 2.86102L16.0202 6.55102L15.3902 7.18102L14.1302 5.92102C13.7702 5.56102 13.2302 5.56102 12.8702 5.92102C12.5102 6.28102 12.5102 6.82102 12.8702 7.18102L14.1302 8.44102L12.8702 9.79102L12.2402 9.16102C11.8802 8.80102 11.3402 8.80102 10.9802 9.16102C10.6202 9.52102 10.6202 10.061 10.9802 10.421L11.6102 11.051L10.3502 12.311L9.18018 11.051C8.82018 10.691 8.28018 10.691 7.92018 11.051C7.56018 11.411 7.56018 11.951 7.92018 12.311L9.18018 13.571L7.92018 14.831L7.29018 14.201C6.93018 13.841 6.39018 13.841 6.03018 14.201C5.67018 14.561 5.67018 15.101 6.03018 15.461L6.66018 16.091L6.12018 16.631Z"
      fill="#BEC7DC"
    />
  </svg>
);
